import { useMutation } from "@apollo/client/react";
import { REJECT_INVOICE_UPLOAD_UNIT } from "../../mutations/documentHandler/rejectInvoiceUploadUnit";
import GET_ALL_UPLOAD_UNITS from "../../queries/documentHandler/getAllUploadUnits";

export const useRejectInvoiceUploadUnit = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: () => void;
}) => {
  const [rejectUploadUnit, { data, loading, error }] = useMutation(
    REJECT_INVOICE_UPLOAD_UNIT,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_ALL_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    }
  );

  return { rejectUploadUnit, data, loading, error };
};
